var _g, _g2, _path, _path2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodpressure1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.5 297.5",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#337a10",
    stroke: "#337a10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDD"
    },
    d: "M67.825,269.98v0.71c0,3.59-2.93,6.51-6.52,6.51h-17.6c-3.59,0-6.51-2.92-6.51-6.51v-0.71 c0-3.59,2.92-6.52,6.51-6.52h17.6C64.895,263.46,67.825,266.39,67.825,269.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.445,
    y: 26.95,
    style: {
      fill: "#DDD"
    },
    width: 13.74,
    height: 115.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.235,
    y: 26.95,
    style: {
      fill: "#ffffff"
    },
    width: 81.31,
    height: 115.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDDDDDDD"
    },
    d: "M90.785,44.78c-1.27,0.19-2.46,0.78-3.37,1.68c-1.12,1.12-1.76,2.67-1.76,4.26 s0.64,3.13,1.76,4.25c0.91,0.91,2.1,1.5,3.37,1.69c-2.39,12.02-11.88,21.5-23.89,23.89c-0.2-1.27-0.78-2.46-1.69-3.37 c-1.12-1.12-2.67-1.76-4.25-1.76c-1.59,0-3.14,0.64-4.25,1.76c-0.92,0.91-1.5,2.1-1.69,3.37c-12.02-2.39-21.5-11.88-23.89-23.89 c1.26-0.19,2.45-0.79,3.36-1.69c1.12-1.12,1.77-2.66,1.77-4.25s-0.65-3.14-1.77-4.26c-0.9-0.9-2.1-1.49-3.36-1.68 c2.77-13.94,15.09-24.48,29.83-24.48S88.015,30.84,90.785,44.78z M66.965,50.72v-16.9c0-3.32-2.69-6.01-6.01-6.01 c-3.32,0-6.02,2.69-6.02,6.01v16.9c0,3.32,2.7,6.01,6.02,6.01C64.275,56.73,66.965,54.04,66.965,50.72z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.595,16.93v135.15c0,5.53-4.49,10.02-10.03,10.02h-74.44v67.79c0,27.83-22.64,50.47-50.47,50.47h-69.62 c-3.87,9.87-13.49,16.89-24.73,16.89h-17.6c-11.23,0-20.86-7.02-24.73-16.89h-2.05c-5.53,0-10.02-4.49-10.02-10.03 c0-5.53,4.49-10.02,10.02-10.02h2.05c3.87-9.88,13.5-16.9,24.73-16.9h17.6c11.24,0,20.86,7.02,24.73,16.9h69.62 c16.78,0,30.42-13.65,30.42-30.42V162.1h-13.74v17.11c0,27.83-22.64,50.47-50.46,50.47h-20.48c-27.83,0-50.47-22.64-50.47-50.47 v-79.03c-23.04-4.66-40.44-25.07-40.44-49.46c0-27.83,22.64-50.47,50.47-50.47c27.82,0,50.46,22.64,50.46,50.47 c0,24.39-17.4,44.8-40.44,49.46v79.03c0,16.77,13.65,30.42,30.42,30.42h20.48c16.77,0,30.41-13.65,30.41-30.42V162.1h-6.86 c-5.54,0-10.03-4.49-10.03-10.02V16.93c0-5.54,4.49-10.03,10.03-10.03h135.14C286.105,6.9,290.595,11.39,290.595,16.93z M270.545,142.05V26.95h-81.31v115.1H270.545z M169.185,142.05V26.95h-13.74v115.1H169.185z M87.415,46.46 c0.91-0.9,2.1-1.49,3.37-1.68c-2.77-13.94-15.09-24.48-29.83-24.48s-27.06,10.54-29.83,24.48c1.26,0.19,2.46,0.78,3.36,1.68 c1.12,1.12,1.77,2.67,1.77,4.26s-0.65,3.13-1.77,4.25c-0.91,0.9-2.1,1.5-3.36,1.69c2.39,12.01,11.87,21.5,23.89,23.89 c0.19-1.27,0.77-2.46,1.69-3.37c1.11-1.12,2.66-1.76,4.25-1.76c1.58,0,3.13,0.64,4.25,1.76c0.91,0.91,1.49,2.1,1.69,3.37 c12.01-2.39,21.5-11.87,23.89-23.89c-1.27-0.19-2.46-0.78-3.37-1.69c-1.12-1.12-1.76-2.66-1.76-4.25S86.295,47.58,87.415,46.46z M67.825,270.69v-0.71c0-3.59-2.93-6.52-6.52-6.52h-17.6c-3.59,0-6.51,2.93-6.51,6.52v0.71c0,3.59,2.92,6.51,6.51,6.51h17.6 C64.895,277.2,67.825,274.28,67.825,270.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.965,33.82v16.9c0,3.32-2.69,6.01-6.01,6.01c-3.32,0-6.02-2.69-6.02-6.01v-16.9c0-3.32,2.7-6.01,6.02-6.01 C64.275,27.81,66.965,30.5,66.965,33.82z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodpressure1);
export default __webpack_public_path__ + "static/media/bloodpressure1.2cf5e09f32e7b2d9437d271a5580cd77.svg";
export { ForwardRef as ReactComponent };